import { render } from "./ProductCards.vue?vue&type=template&id=7daf141c"
import script from "./ProductCards.vue?vue&type=script&lang=js"
export * from "./ProductCards.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__